import { BaseProvider } from './core/providers/base'
import { CartEventsProvider } from './core/providers/cart-events'
import { GoogleAnalyticsProvider } from './core/providers/google-analytics'
import { CartActionType } from './UserActionsManager'
// import { Config } from '../ConfigManager'

class AnalyticsInitializer {
  private static instance: AnalyticsInitializer
  private providers: BaseProvider[] = []

  private constructor() {
    //
  }

  public static getInstance(): AnalyticsInitializer {
    if (!AnalyticsInitializer.instance) {
      AnalyticsInitializer.instance = new AnalyticsInitializer()
    }
    return AnalyticsInitializer.instance
  }

  public init(): void {
    const gaProvider = new GoogleAnalyticsProvider(
      {
        // measurementId: Config.googleAnalyticsId,
        measurementId: import.meta.env.VITE_GA_ID,
        method: import.meta.env.VITE_GA_METHOD,
        type: 'google-analytics',
      },
      {
        events: [CartActionType.cartDelete, CartActionType.cartItemDelete],
        type: 'blacklist',
      }
    )
    const cartEventsProvider = new CartEventsProvider({
      events: [CartActionType.cartDelete, CartActionType.cartItemDelete],
      type: 'whitelist',
    })
    gaProvider.initialize()
    this.providers = [gaProvider, cartEventsProvider]
  }

  public getProviders(): BaseProvider[] {
    return this.providers
  }
}

export const analyticsInit = AnalyticsInitializer.getInstance()
